<template>
    <div>
<!--<section class="section ls-features-cards has-background-primary" >
    <div class="container">
        <div class="columns">
            <div class="column is-8-desktop is-offset-2-desktop">
                <div class="ls-section-content has-text-centered ">
                    <h3 class="title has-text-dark">How it works?</h3>

                </div>
            </div>
        </div>

<ul class="steps is-large">
  <li class="step-item">
    <div class="step-marker">1</div>
    <div class="step-details is-primary is-completed">
      <p class="step-title">Create</p>
      <p>Easy drag & drop <br>editor</p>
    </div>
  </li>
  <li class="step-item">
    <div @click="alert()" class="step-marker">2</div>
        <div class="step-details is-primary is-completed">
      <p class="step-title">Integrate</p>
      <p>Connect to your <br>favorite apps</p>
    </div>
  </li>
  <li class="step-item">
    <div class="step-marker">3</div>
        <div class="step-details is-primary is-completed">
      <p class="step-title">Automate</p>
      <p>Generate documents dynamically</p>
    </div>
  </li>
</ul>




    </div>
</section>-->
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>

</style>